import React from "react";
import Logo from "../acepts/logo-24.png";
import "./footer.css";
import { NavLink } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="containers">
      <div className="footer_nav">
        <img src={Logo} alt="Logo img" />
        <ul>
          <li>
            <NavLink to="">About</NavLink>
          </li>
          <li>
            <NavLink to="">Contact</NavLink>
          </li>
          <li>
            <NavLink to="">Advertise</NavLink>
          </li>
        </ul>
      </div>
      <div className="footer_main my-4">
        <h2>Барча хуқуқлар ҳимояланган © {new Date().getFullYear()}</h2>
        <p>
          Сайт материалларидан тўлиқ ёки қисман фойдаланилганда веб-сайт манзили
          кўрсатилиши шарт.​ Веб-сайт ОАВ сифатида 2018 йил 26 октябрь куни
          Ўзбекистон Республикаси Президенти Администрацияси ҳузуридаги Ахборот
          ва оммавий коммуникациялар агентлигида 1089 рақам билан рўйхатга
          олинган. Расмий хабарларда ва блогларда кетган маълумот - мақолаларга
          муаллифлар ва блогерларнинг ўзлари масъулдирлар.
        </p>
        <h3>
          Таҳририят манзили: Фарғона вилояти, Қўштепа тумани, Каттакўл МФЙ,
          Каттакўл кўчаси, 123-уй. Электрон манзил: info@tahlil24.uz
        </h3>
        <div className="footer_icons">
          <div className="foo_line"></div>
          <div className="foo_icon mx-2">
          <a href="https://www.facebook.com/tahlil24/"><i className="bi bi-facebook"></i></a>
          <a href="https://twitter.com/tahlil24?t=za_WYLijk6A-rFmZ0pHZwQ&s=09"><i className="bi bi-twitter"></i></a>
          <a href="https://www.instagram.com/tahlil24_uz/"><i className="bi bi-instagram"></i></a>
            <a href="https://t.me/tahlil24uz"><i className="bi bi-telegram"></i></a>
          </div>
          <div className="foo_line"></div>
        </div>
      </div>
    </footer>
  );
};
